import {type FunctionalComponent, h} from '@stencil/core';
import {SrtRating} from '../../../result-cards/utils/srt-rating';
import type {SrtDocument} from '../../../../../api/model/response/documents/public/SrtDocument';
import type {SearchApiGenericResult} from '../../../../../api/model/response/documents/SearchResult';
import type { ExstUnionUiModel } from '../../../../../models/ui/documents/exchange/exst-union-ui.model';
import type {Strategies} from '../../../../strategies/Strategies';
import type {InternalAddressesStrategyService} from '../../../../strategies/InternalAddressesStrategyService';
import {INTERNAL_ADDRESSES} from '../../../../strategies/utils/variables';
import type {DocumentBaseUiModel} from '../../../../../models/ui/documents/document-base-ui.model';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';

export interface GenericCardContainer {
   gridView?: boolean;
   isDashboardView?: boolean;
   doc: SearchApiGenericResult | ExstUnionUiModel | DocumentBaseUiModel;
   srt: boolean;
   labelProvider: labelProviderInterface;
   strategies: Strategies;
   rtl?: boolean;
   isDashboardListVariant?: boolean;
   isVideo?: boolean;
}

export const GenericCardContainer: FunctionalComponent<GenericCardContainer> = (props, children) => {
    const { doc, gridView, srt, labelProvider, isDashboardView, strategies, rtl, isDashboardListVariant, isVideo } = props;
    const internalAddressesStrategy:InternalAddressesStrategyService = strategies.for(INTERNAL_ADDRESSES);

    return <div class={{
      'result-card__border-wrapper': true,
      'dashboard-view--list-like': isDashboardView && isDashboardListVariant,
    }}>
      <div class={{
        'result-card__container': true,
        'grid-view': gridView,
        'dashboard-view--grid-like': isDashboardView && !isDashboardListVariant,
        'no-image': !doc.thumbnailUrl,
      }}
      dir={rtl ? 'rtl' : 'auto'}
      data-card-area={'background'}
      >
        <a class='result-card__link' href={isVideo ? void(0) : doc.url}
          target={internalAddressesStrategy.isExternalLink(doc.url) ? '_blank' : '_self'} >
          <div class="result-card__content">
            {children}
          </div>
        </a>
        {srt && (
          <SrtRating doc={doc as unknown as SrtDocument}
            labelProvider={(e, f) => labelProvider(e, f)}/>
        )}
      </div>
    </div>;
};
